import { locationApi } from "../api";

/** Retângulo de busca no formato do LocationIQ: oeste, norte, leste, sul (lon1,lat1,lon2,lat2). */
export type PlacesViewbox = { west: number; north: number; east: number; south: number };

/**
 * findAllPlacesWithIqLocation - Function that finds places using Iq Location
 * /autocomplete?limit&q&key&countrycodes&dedupe&viewbox&bounded
 * method GET
 * Sempre restrito ao Brasil. Com `viewbox` e `bounded` (padrão), só devolve lugares dentro daquela área;
 * com `bounded=false` a área só dá preferência aos resultados próximos, sem excluir os de fora.
 * @async-function
 */
const findAllPlacesWithIqLocation = async (query: string, viewbox?: PlacesViewbox, bounded: boolean = true) => {
    const response = await locationApi.get(
        `/autocomplete`, {
            params: {
                limit: 8,
                q: query,
                countrycodes: "br",
                dedupe: 1,
                ...(viewbox ? {
                    viewbox: `${viewbox.west},${viewbox.north},${viewbox.east},${viewbox.south}`,
                    ...(bounded ? { bounded: 1 } : {}),
                } : {}),
            },
            headers: {
                Accept: "application/json"
            }
        }
    );
    return response;
};
export default findAllPlacesWithIqLocation;
